export enum ImageTypeEnum {
    Resolution = 1,
    Bank = 2,
    Profile = 3,
    MemberBank = 4,
}
